import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke113aRequest, Sgke113aResponse, Sgke113aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke113aService {

  /**
   * コンストラクタ
   * @param {Sgke113aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @param {TimeApiService} timeApiService
   * @memberof UsedSgke113aService
   */
  constructor(public service: Sgke113aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig,
    private timeApiService: TimeApiService
  ) { }

  /**
   * Sgke113aAPI実行
   *
   * @param {Sgke113aRequest} request
   * @return {*}  {Observable<Sgke113aResponse>}
   * @memberof UsedSgke113aService
   */
  public doSgke113a(request: Sgke113aRequest): Observable<Sgke113aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.service.sgke113aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE113A');
          return throwError(err.message);
        })
      );
  }

}

